import st_router_h5 from "./st_router.h5"

export default st_router_h5